import ApiService from './api.service';

// BE resource REST = `insurance-companies` (danh mục BH cho luồng GBH).
const BASE_URL = 'insurance-companies';

/**
 * InsuranceService — danh mục công ty BH + giám định viên (SO-001 chọn công ty BH).
 * BE controller: backend/src/modules/service-order/controllers/insurance.controller.ts
 */
export const InsuranceService = {
  /**
   * List/search công ty BH.
   * @param {Object} params { search, page, limit }
   */
  getCompanies(params) {
    return ApiService.query(BASE_URL, { params });
  },

  /**
   * List giám định viên. Danh mục PHẲNG — KHÔNG lọc theo công ty BH (Q&A #12: 1 GĐV giám định cho
   * nhiều công ty, hoặc không thuộc công ty nào).
   * @param {Object} params { search }
   */
  getSurveyors(params) {
    return ApiService.query(`${BASE_URL}/surveyors`, { params });
  },

  /**
   * Quick-add công ty BH.
   * @param {Object} data { name, shortName?, taxCode?, paymentTermDays? }
   */
  createCompany(data) {
    return ApiService.post(BASE_URL, data);
  },

  /**
   * Quick-add giám định viên. Trùng tên → BE trả lại bản ghi cũ (không tạo bản sao).
   * @param {Object} data { fullName, phone? }
   */
  createSurveyor(data) {
    return ApiService.post(`${BASE_URL}/surveyors`, data);
  },
};

export default InsuranceService;
